/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Typography, breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  headline?: string | null;
  visible?: boolean;
};

const styles: Record<string, Interpolation<Theme>> = {
  headline: () => css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('xs')} {
      margin-bottom: 24px;
    }
  `,
};

function Headline({ headline, visible }: Props) {
  if (!visible) {
    return null;
  }
  return (
    <Typography variant="d2semibold" css={styles.headline} color="inherit">
      {headline}
    </Typography>
  );
}

export default Headline;
